import { Component, Prop, PropSync, VModel, Vue } from 'vue-property-decorator';
import { Color } from '@/models/Color';

@Component<ColourAutocomplete>({})
export default class ColourAutocomplete extends Vue {
  //#region @VModel

  @VModel()
  protected internalValue!: string | Color;

  //#endregion

  //#region @PropSyncs

  @PropSync('searchInput')
  protected internalSearchInput!: string;

  //#endregion

  //#region @Props

  @Prop({ default: 'keyboard_arrow_down' })
  protected appendIcon!: string;

  @Prop({ default: '#49B39D' })
  protected color!: string;

  @Prop({ default: () => [] })
  protected items!: Color[];

  @Prop({ default: 'Choose a colour' })
  protected label!: string;

  @Prop({ default: 'Colour' })
  protected placeholder!: string;

  @Prop({ default: false })
  protected returnObject!: boolean;

  @Prop({ default: 'Colour search' })
  protected searchPlaceholder!: string;

  //#endregion

  //#region Handlers

  protected onFocus(): void {
    this.$emit('focus');
  }

  //#endregion

  //#region Helpers

  protected itemText(item: Color): string {
    return ` ${item && (item as { parent_id?: string }).parent_id ? '○ ' : ''}${item.name}`;
  }

  //#endregion
}
